// extracted by mini-css-extract-plugin
module.exports = {"wrap":"yssl_wrap_-uUIA","fanhui":"yssl_fanhui_13yjv","btnWrap":"yssl_btnWrap_1ymzg","btn":"yssl_btn_3cI8j","fullScreen":"yssl_fullScreen_7axsj"};